import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ArtifactItem, MentorBase } from '../../types/mentor'
import { RootState } from '../store'

export interface ArtifactsState {
  artifactsList: ArtifactItem[]
  artifactPanelOpen: boolean
  summarization: string
  suggestedMentors: MentorBase[] | null
}

const initialState: ArtifactsState = {
  artifactsList: [],
  artifactPanelOpen: false,
  summarization: '',
  suggestedMentors: null,
}

export const artifactsSlice = createSlice({
  name: 'mentors',
  initialState,
  reducers: {
    setArtifactsList: (state, action: PayloadAction<ArtifactItem[]>) => {
      state.artifactsList = action.payload
    },
    toggleArtifactPanel: (state, action: PayloadAction<boolean>) => {
      state.artifactPanelOpen = action.payload
    },
    setSummarization: (state, action: PayloadAction<string>) => {
      state.summarization = action.payload
    },
    setSuggestedMentors: (state, action: PayloadAction<MentorBase[]>) => {
      state.suggestedMentors = action.payload
        ? action.payload.reduce((acc: MentorBase[], mentor: MentorBase) => {
            if (!acc.some(m => m.mentorId === mentor.mentorId)) {
              acc = [...acc, mentor]
            }
            return acc
          }, state?.suggestedMentors || [])
        : null
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  setArtifactsList,
  toggleArtifactPanel,
  setSummarization,
  setSuggestedMentors,
} = artifactsSlice.actions
export const getArtifactsState = (state: RootState) => state.artifactsReducer

export default artifactsSlice.reducer
